// Right-side panel using Radix Dialog primitive but slid in from the right.
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { cn } from "@/lib/utils";
import type { ComponentPropsWithoutRef, ReactNode } from "react";

export const Sheet = DialogPrimitive.Root;

interface SheetContentProps extends ComponentPropsWithoutRef<typeof DialogPrimitive.Content> {
  children: ReactNode;
}

export function SheetContent({ className, children, ...props }: SheetContentProps) {
  return (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay
        className="fixed inset-0 z-40 bg-black/40 backdrop-blur-[2px] animate-fade-in"
      />
      <DialogPrimitive.Content
        className={cn(
          "fixed right-0 top-0 bottom-0 z-50 w-full sm:max-w-md",
          "border-l bg-card shadow-2xl",
          "animate-slide-in scrollbar-thin overflow-y-auto",
          className,
        )}
        {...props}
      >
        <DialogPrimitive.Close className="absolute right-4 top-4 rounded-md p-1 hover:bg-accent z-10">
          <X className="h-4 w-4" />
        </DialogPrimitive.Close>
        {children}
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  );
}
